<template>
  <div
    v-if="loaded"
    class="content"
    :class="moduleInfo.Module.CssClass"
  >
    <div
      class="container max-w-screen-3xl mx-auto mt-16 mb-16 lg:mt-20 lg:mb-32"
      :class="{'px-0': moduleInfo.Module.ModuleProperties.ModuleShowAsCountdown === 'True'}"
    >
      <!-- banner naslov, CTA -->
      <div
        class="banner max-w-screen-2xl mx-auto relative my-12 h-fixed-460 max-h-460"
        :class="{'max-w-screen-3xl h-full min-h-700 lg:min-h-400 max-h-800 lg:max-h-500': moduleInfo.Module.ModuleProperties.ModuleShowAsCountdown === 'True'}"
      >
        <div
          class="overlay-gradient absolute z-1 left-0 right-0 top-0 w-full h-full"
        />
        <!-- <img class="w-full h-full object-cover" src="https://i.ibb.co/x248n8Q/htz-cover.jpg" width="100%" height="100%" alt="banner"> -->
        <!-- <img class="w-full h-full object-cover" width="100%" height="100%" alt="banner"
                  v-if="moduleInfo.Module.ModuleProperties.Photo"
                  :src="moduleInfo.Module.ModuleProperties.Photo"> -->
        <vue-picture
          v-if="firstModuleDataItem?.MediaGallery.length"
          :image="firstModuleDataItem.MediaGallery[0]"
          css-class="banner-img object-cover"
        />

        <div class="container max-w-screen-xl absolute z-1 vh-center">
          <div
            v-if="moduleInfo.Module.ModuleProperties.ModuleShowAsCountdown === 'True'"
            class="max-w-835 text-center mx-auto"
          >
            <div class="relative">
              <h2
                v-if="hasPropertyValue('ModuleCountdownTimerText', moduleInfo.Module.ModuleProperties, firstModuleDataItem)"
                class="countdown-text text-48 leading-none lg:text-96 mb-4 text-white font-origo px-16"
                v-html="getPropertyValue($t, 'ModuleCountdownTimerText', moduleInfo.Module.ModuleProperties,firstModuleDataItem)"
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="180"
                height="180"
                viewBox="0 0 545 531"
                class="splash-v3 text-white absolute left-0 right-0 top-0 z-1 w-full"
                style="transform: rotate(-45deg)"
              >
                <g
                  fill="text-white"
                  fill-rule="evenodd"
                >
                  <path
                    d="M176.248 65.203c1-1.818 2.421-3.77 1.962-5.157-1.638-1.026-3.23-1.926-4.473-1.575-2.376 3.168-1.07 5.274 2.511 6.732M212.862 103.853c1.827 2.169 6.183 3.528 8.028-.018-1.602-3.105-6.678-4.077-8.028.018M167.36 81.226c3.132-.972 2.934-4.194 2.034-6.903-2.394.972-3.699 5.32-2.034 6.903M156.606 74.569c.207-2.277-1.485-6.048-5.022-5.436-4.023 3.906 2.493 8.352 5.022 5.436M280.774 155.304c.909.504 1.827.999 2.727 1.503 1.989-2.331-1.81-4.428-2.727-1.503M68.813 42.906c-2.997 10.54 2.232 18.605 6.273 27 .054-9.642.954-19.558-6.273-27M239.212 142.882c-.45-.243-.918-.504-1.368-.747-.27.396-.55.747-1.062.297-.243.468-.504.918-.756 1.377.396.27.756.54.315 1.053.45.252.9.504 1.359.756.27-.396.558-.756 1.062-.306.252-.45.495-.918.756-1.368-.396-.26-.756-.549-.306-1.062M128.87 89.078c2.646-2.979-1.09-6.156-3.951-5.75-.504.908-1.008 1.817-1.503 2.735.432 1.548 3.906 3.465 5.454 3.015M5.38 50.023c-1.224.378-2.097 1.99-2.943 3.717 2.691 2.016 4.905 2.421 5.976-1.143-1.8-.63-.792-2.06-3.033-2.574M326.574 230.452c-1.305 3.852 2.583 4.338 5.697 5.823.864-1.206.063-1.926.819-3.114-2.205-1.026-4.761-3.23-6.516-2.709M79.69 13.196C78.124 26.458 97.894 30.65 109.98 32.71c2.957-4.59-5.629-5.837-4.606-9.864 2.634-3.51 2.266-6.15 4.32-9.494-3.657-16.486-28.004-17.17-30.004-.157M307.997 225.06c-.477-1.008-1.332-1.908-3.033-2.565-2.043 2.142 1.854 4.572 3.033 2.565M312.48 228.61c.982 2.583 3.142 4.833 7.066 6.57 2.87-3.384-4.23-8.478-7.065-6.57M93.232 137.236c3.438 2.6 5.904 1.89 7.425-2.142-3.573-2.412-7.227-1.36-7.425 2.142M95.529 158.568c2.862 1.314 5.463 1.701 7.038-1.458 1.215-5.31-7.857-3.23-7.038 1.458M261.289 249.752c-.378.675-.756 1.36-1.134 2.052.324 2.007 2.556 3.465 5.4 4.761 1.422-2.952-2.097-6.723-4.266-6.813M18.07 116.37c-2.24 3.14.559 4.814 2.512 6.74 2.673-1.332-.27-5.013-2.511-6.74M195.086 216.534c-1.098 3.564.45 6.372 4.185 8.55 3.15-2.142-.063-8.604-4.185-8.55M175.946 249.67c-2.62 1.313-4.824 6.48-.666 7.658 3.438-1.548 2.952-5.949.666-7.659M121.552 201.29c-2.448 1.314-5.607 5.21-2.403 7.587 2.151.297 4.78-4.347 4.455-6.462-.684-.37-1.359-.747-2.052-1.125M169.378 244.185c-.63 1.8-2.061.8-2.565 3.042 1.206 1.179 1.017 2.772 3.339 3.627.882-1.62 2.286-1.36 2.943-3.717-.37-1.233-1.98-2.106-3.717-2.952M228.605 278.883c-1.54 3.7-.126 6.543 3.132 8.856 2.682-4.032.099-6.534-3.132-8.856M150.513 91.35c-12.303 12.248 16.39 19.873 11.29 1.902-4.13-3.307-8.59-4.575-11.29-1.901M91.169 292.06c-2.007 3.257.819 5.12 3.204 7.118.54-2.835.351-5.454-3.204-7.119M131.202 324.407c-2.574 4.074-1.89 7.216-.054 10 2.088-1.844 3.798-7.991.054-10M229.243 427.826c.204.105.405.212.61.32 1.45-.928.943-2.343 2.207-2.897-.727-.4-.177-1.149.287-1.877-1.368-1.751-2.629-4.008-5.271-3.29.043-.177.217-.387.024-.497-1.768.307-3.146 1.195-4.262 2.32.49.595.33 1.7-.491 1.772.408 2.53 3.879 6.605 6.896 4.149"
                    transform="rotate(51 166.538 350.069)"
                  />
                </g>
              </svg>
            </div>
            <div

              class="flex flex-col lg:flex-row items-center justify-around p-lg lg:mb-4 text-white font-origo"
              v-html="countDownTime"
            />
          </div>
          <div
            v-else
            class="max-w-835"
            :class="{
              'max-w-full text-center':
                moduleInfo.Module.ModuleProperties.ModuleHasCenterContent ===
                'True',
            }"
          >
            <p
              v-if="
                hasPropertyValue(
                  'Overtitle',
                  moduleInfo.Module.ModuleProperties,
                  firstModuleDataItem
                )
              "
              class="overtitle text-white"
            >
              {{ getPropertyValue($t, "Overtitle", moduleInfo.Module.ModuleProperties,firstModuleDataItem) }}
            </p>
            <p
              v-if="hasPropertyValue('HighlightedText', moduleInfo.Module.ModuleProperties, firstModuleDataItem)"
              class="p-lg mb-4 text-white"
              v-html="getPropertyValue($t, 'HighlightedText', moduleInfo.Module.ModuleProperties,firstModuleDataItem)"
            />
            <VirtualLink
              v-if="hasPropertyValue('UrlText', moduleInfo.Module.ModuleProperties, firstModuleDataItem)"
              :href="getHref(moduleInfo.Module.ModuleProperties, firstModuleDataItem)"
              :class="'btn ' + btnClass + ' '"
            >
              {{ getPropertyValue($t, 'UrlText', moduleInfo.Module.ModuleProperties, firstModuleDataItem) }}
            </VirtualLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VuePicture from "../../includes/VuePicture";
  import {selfDataRequestMixin} from "@/mixins";
  import {dateFromString} from "@/services/date-utilis";
  export default {
    name: "Banner",
    components: {
      VuePicture,
    },
    mixins: [selfDataRequestMixin],
    props: {
      moduleInfo: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        galleryType: 'bannerImage',
        countDownTime: "",
        polling: null,
        target: "_self",
        btnClass: this.moduleInfo.Module.ModuleProperties.ModuleButtonType?.length > 0 ? this.moduleInfo.Module.ModuleProperties.ModuleButtonType : 'btn-transparent-blue'
      };
    },
    computed: {
      externalUrl() {
        const regex = new RegExp(`((http:|https:)?(//)(?!${window.location.host})[\\w\\.\\/\\-=?#]+)`, 'g')
        console.log(this.url);
        console.log(regex.test(this.url));
        return regex.test(this.url);
      }
    },
    created () {
      if(this.moduleInfo.Module.ModuleProperties.ModuleCountdownTimer){
        this.countDown()
      }
    },
    beforeUnmount () {
      clearInterval(this.polling)
    },
    methods: {
      countDown() {
      const countDownDate = this.moduleInfo.Module.ModuleProperties.ModuleCountdownTimer;
      this.polling = setInterval(() => {
          // Set the date we're counting down to

        // TODO izmjeniti kada promnjene datun u modulima -> const countDownDate2 = new Date(countDownDate).getTime();
        const countDownDate2 = new Date(countDownDate).getTime();
        // Update the count down every 1 second
            // Get today's date and time
            var now = new Date().getTime();

            // Find the distance between now and the count down date
            var distance = countDownDate2 - now;

            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);


              this.countDownTime = "<div class='time-elem days'>"+ days + "<span>" + this.$t("loc_days") + "</span></div> <div class='time-elem'>" + hours + "<span>" + this.$t("loc_hours") + "</span></div> <div class='time-elem'>" + minutes + "<span>" + this.$t("loc_minutes") + "</span></div> <div class='time-elem'>" + seconds + "<span>" + this.$t("loc_seconds") + "</span><div>";

      }, 1000)
    }

    }
  };
</script>
<style lang="scss" scoped>
.banner{
  .btn {
    @apply w-auto min-w-200 pr-8;
    width: fit-content;
  }
}
</style>
